import { PermissionType } from '@/js/libs/generated/permissions/types';
export const AGENCY_ROLES = [
    PermissionType.SELF_BOOKING,
    PermissionType.BOOK_CAMPAIGNS,
    PermissionType.MANAGE_ACCOUNTS,
    PermissionType.MANAGE_PRINT_CREATIVES,
    PermissionType.MANAGE_DIGITAL_CREATIVES,
];
